import assign from 'object-assign';
import * as messages from "../../../constants/ToastrConstants";
import { showToastrSuccess, showToastrError, showToastrWarning, showToastrInfo } from "../../../util/toastr";
import lusApi from "../../../api/e-loket/lusApi";
import lusTypeApi from "../../../api/shared/lusTypeApi";
import { LusTypeIds } from "../../../constants/DomainConstants";
import moment from 'moment';
import { ValidationMessageTypes } from "../../../constants/ComponentConstants";
import FilesHelper from "../../common/FilesHelper";
import { formatFilesForSave, getFilesComponentProps } from "../../../components/common/FilesHelperUtil";
import { prependRoot } from "../../../util/prependRoot.js";
import { getApiRoot } from "../../../store/configureStore.js";
import { parse } from 'wellknown';
import cloneDeep from 'lodash/cloneDeep';
import domToImage from 'dom-to-image';
import * as types from "../../../constants/ComponentConstants";
import * as GpxService from "../../common/map/GpxService";
import { FeatureNames } from "../../common/map/MapConstants";

export default class LusPageHelper {

	constructor(context, redirector) {
		this.context = context;
		this.redirector = redirector;
	}

	markerNames() {
		const props = this.context.props;
		return {
			bepijlingMarkerName: props.bepijlingMarkerName,
			bevoorradingMarkerName: props.bevoorradingMarkerName
		};
	}

	init() {
		const context = this.context;
		const ajaxActions = context.props.ajaxActions;
		const params = context.props.match.params;
		let lusId = params.lusId;

		context.filesHelper = new FilesHelper(context, lusId);

		ajaxActions.started();
		lusApi.getLus(lusId)
			.then((response) => {
				ajaxActions.ended();
				this.processModel(response, true);
			})
			.catch((ex) => {
				ajaxActions.failed();
				context.props.throwException(ex);
			});

		ajaxActions.started();
		lusTypeApi.getLusTypes()
			.then((response) => {
				ajaxActions.ended();
				context.setState({ lusTypes: response.data });
			})
			.catch((ex) => {
				ajaxActions.failed();
				context.props.throwException(ex);
			});
	}

	processModel(response) {
		const context = this.context;
		let model = response.data;

		if (model.conflicterendeLussen && model.conflicterendeLussen.length) {
			const tochtColorMap = new Map();
			let colorCounter = 0;

			model.conflicterendeLussen.forEach(conflicterendeLus => {
				const idTocht = conflicterendeLus.idTocht;

				if (!tochtColorMap.has(idTocht)) {
					const colorIndex = colorCounter % types.ConflictColorArray.length;
					tochtColorMap.set(idTocht, types.ConflictColorArray[colorIndex]);
					colorCounter++;
				}

				conflicterendeLus.geoJson = GpxService.routesOnlyGeoJson(
					conflicterendeLus.gpx,
					[FeatureNames.BEVOORRADINGSZONE, context.props.bepijlingMarkerName]);
				conflicterendeLus.color = conflicterendeLus.isDoorgestuurdTerGoedkeuring
					? types.COLOR_GRAY
					: tochtColorMap.get(idTocht);
			});
		}

		this.loadRouteModel(model.gpxContent);

		context.setState({
			model,
			originalGpxContent: model.gpxContent,
			routeEdited: false
		});

		this.getAndSetWerkelijkeLusAfstand();

		if (model.showANBWarning) {
			showToastrWarning("Dossiers die minder dan 35 dagen voor de tocht worden ingediend kunnen niet meer door ANB beoordeeld worden. De routes van deze tocht mogen niet door ANB gebied lopen. Gelieve je route aan te passen.", true, true);
		}
		if (model.showAWVWarning) {
			showToastrWarning("Dossiers die minder dan 35 dagen voor de tocht worden ingediend kunnen niet meer door het Agentschap Wegen en Verkeer beoordeeld worden.	De routes van deze tocht mogen niet langs Gewestwegen/Autosnelwegen lopen of Gewestwegen kruisen. Gelieve je route aan te passen.", true, true);
		}
		context.props.loadLayout(model.tocht.naam + " " + moment(model.tocht.datum).format("DD/MM/YYYY"), model.tocht.id, model.validatiestatusses, model.id, model.svlDossierId);
		context.props.validatieStatussenLoaded(model.validatiestatusses);
	}

	loadRouteModel(gpxContent) {
		const context = this.context;
		const props = context.props;
		let model = context.state.model;

		const routeModel = GpxService.toRouteModel(gpxContent, this.markerNames());

		props.enableTopNav();
		props.showSideNav();

		if (model) {
			model.gpxContent = gpxContent;
		}

		context.setState({
			model,
			routeModel,
			mapBounds: GpxService.mapBoundsOfRouteModel(routeModel),
			isMapEditable: false,
			drawingRoute: false
		});
	}

	routeUpdated(newRouteModel) {
		const context = this.context;
		const props = context.props;
		let model = context.state.model;
		let gpx = null;

		if (newRouteModel) {
			gpx = GpxService.serializeToGpx(newRouteModel, model.gpxFilename, this.markerNames());
			model.gpxContent = gpx;
		}
		else {
			model.gpxContent = null;
			model.gpxFilename = null;
		}

		this.getAndSetWerkelijkeLusAfstand();
		props.enableTopNav();
		props.showSideNav();

		this.hideErrors(['gpxContent', 'gpxFilename']);
		context.setState({
			model,
			routeModel: newRouteModel,
			mapBounds: GpxService.mapBoundsOfRouteModel(newRouteModel),
			originalGpxContent: gpx,
			hasUnsavedChanges: true,
			isMapEditable: false,
			routeEdited: true
		});
	}

	routeCreated(newFeature) {
		const context = this.context;
		const props = context.props;
		let model = context.state.model;
		let routeModel = null;
		let gpx = null;

		if (newFeature) {
			const featureName = `${model.tocht.naam}_${moment(model.tocht.datum).local().format('YYYY-MM-DD')}_${model.naam}.gpx`;

			routeModel = { routes: [newFeature.geometry], zones: [] };
			gpx = GpxService.serializeToGpx(routeModel, featureName, this.markerNames());

			model.gpxFilename = featureName;
			model.gpxContent = gpx;
			model.gpxUploadDatum = moment().local().format('YYYY-MM-DD hh:mm:ss');
		}

		this.getAndSetWerkelijkeLusAfstand();
		props.enableTopNav();
		props.showSideNav();
		this.hideErrors(['gpxContent', 'gpxFilename']);
		context.setState({
			model,
			routeModel,
			mapBounds: GpxService.mapBoundsOfRouteModel(routeModel),
			originalGpxContent: gpx,
			hasUnsavedChanges: true,
			isMapEditable: false,
			drawingRoute: false
		});
	}

	reverseRoute() {
		const context = this.context;
		let model = context.state.model;

		const reversedModel = GpxService.reverseRouteDirection(context.state.routeModel);
		const gpx = GpxService.serializeToGpx(reversedModel, model.gpxFilename, this.markerNames());
		model.gpxContent = gpx;

		context.setState({
			model,
			routeModel: reversedModel,
			originalGpxContent: gpx,
			hasUnsavedChanges: true
		});
	}

	getAndSetWerkelijkeLusAfstand() {
		const context = this.context;
		let state = context.state;
		let model = state.model;
		const ajaxActions = context.props.ajaxActions;
		let werkelijkeAfstand = 0;
		lusApi.getWerkelijkeLusAfstand({ gpx: model.gpxContent })
			.then((response) => {
				werkelijkeAfstand = response.data;
				const formattedAfstand = (parseFloat(werkelijkeAfstand) / 1000).toFixed(2);
				context.setState({
					werkelijkeAfstand: formattedAfstand
				});

			})
			.catch((ex) => {
				ajaxActions.failed();
				context.props.throwException(ex);
			});

	}

	editRoute(mapCallback) {
		const context = this.context;
		let state = context.state;
		const props = context.props;
		let model = state.model;
		const ajaxActions = context.props.ajaxActions;

		context.setState({
			isMapLoading: true
		});

		props.disableTopNav();
		props.hideSideNav();

		return lusApi.loadSimplifiedWktForGpx({ gpx: model.gpxContent })
			.then((response) => {
				const geometry = parse(response.data);

				if (!geometry || geometry.coordinates.length > props.maxMapFeaturesToLoad) {
					showToastrWarning("De opgeladen GPX is te complex om rechtstreeks via de VTT-tool te wijzigen. Wil je de route aanpassen dan kan je deze GPX verwijderen en een nieuwe GPX met de gewijzigde route opladen.", true, true);
					context.setState({
						isMapLoading: false,
						isMapEditable: false
					});

					props.enableTopNav();
					props.showSideNav();

					return false;
				} else {
					const routeModel = assign({}, state.routeModel, { routes: [geometry] });

					context.setState({
						isMapLoading: false,
						isMapEditable: true,
						routeModel,
						mapBounds: GpxService.mapBoundsOfRouteModel(routeModel)
					}, mapCallback);

					return true;
				}
			})
			.catch((ex) => {
				ajaxActions.failed();
				context.props.throwException(ex);
			});
	}

	markersEditStart() {
		this.context.setState({
			isMapEditable: true
		});
	}

	drawingRoute() {
		const context = this.context;
		const props = context.props;

		props.disableTopNav();
		props.hideSideNav();

		context.setState({
			drawingRoute: true
		});
	}

	resetGpx() {
		const state = this.context.state;
		const gpxContent = state.originalGpxContent ? state.originalGpxContent : state.model.gpxContent;
		this.loadRouteModel(gpxContent);
	}

	change(event) {
		const context = this.context;
		const value = event.target.value;
		const property = event.target.name;

		const model = context.state.model;
		model[property] = value;

		switch (property) {
			case "lusTypeId":
				if (!LusTypeIds.ANDERE.includes(value))
					model.anderType = null;
				break;
			case "toegankelijkVoorGSporters":
			case "toegankelijkVoorRolstoelgebruikers":
				if (value === false || value === "false")
					model.toelichtingToegankelijkheid = null;
				else if (value === true || value === "true")
					model.toelichtingToegankelijkheid = model.toelichtingToegankelijkheid || "";
				break;
			default:
				break;
		}

		context.setState({
			model,
			hasUnsavedChanges: true,
			showAnbPopup: false
		});
	}

	changeBevoorradingstentenInANBGebied(event) {
		const value = event.target.value;
		const property = event.target.name;

		const model = this.context.state.model;
		model[property] = value;

		if (value === false || value === "false")
			model.afmetingenBevoorradingstenten = null;
		else if (value === true || value === "true")
			model.afmetingenBevoorradingstenten = ""; // lege string anders -> The prop `value` is marked as required in `TextAreaInput`, but its value is `null`.

		this.context.setState({
			model,
			hasUnsavedChanges: true,
			showAnbPopup: model.showAnbPopup
		});
	}

	dropGPXBestand(files) {
		let state = this.context.state;
		let model = state.model;
		let reader = new FileReader();

		const mappedOnDrop = (context) => {
			return (event) => {
				let gpxContent = event.target.result;
				if (GpxService.isValidGpx(gpxContent)) {
					let file = files[0];
					gpxContent = GpxService.stripWaypoints(gpxContent);
					let gpxDropped = !model.gpxContent || (model.gpxContent && model.gpxFilename && file.size !== model.gpxContent.length && model.gpxFilename !== file.name);
					let gpxChanged = model.gpxContent || state.gpxDeleted;
					model.gpxFilename = file.name;
					model.gpxUploadDatum = moment().local().format('YYYY-MM-DD HH:mm:ss');
					let routeModel = GpxService.toRouteModel(gpxContent, this.markerNames());

					if (GpxService.hasRoute(routeModel)) {
						this.hideErrors(['gpxContent', 'gpxFilename']);
						this.loadRouteModel(gpxContent);
						this.getAndSetWerkelijkeLusAfstand();
						context.setState({
							gpxDropped: gpxDropped,
							gpxChanged: gpxChanged,
							originalGpxContent: gpxContent,
							hasUnsavedChanges: context.state.hasUnsavedChanges || gpxDropped
						});
					} else {
						this.deleteGPXBestand();
						this.showError('gpxContent', 'Je GPX bestand bevat geen route. Gelieve je route in de VTT-tool uit te tekenen.');
					}

				} else {
					this.deleteGPXBestand();
					this.showError('gpxContent', 'Je GPX bestand heeft een foutief formaat. Gelieve je route in de VTT-tool uit te tekenen.');
				}
			};
		};

		reader.onload = mappedOnDrop(this.context);

		reader.readAsText(files[0]);
	}

	deleteGPXBestand() {
		let context = this.context;
		let model = context.state.model;
		model.gpxFilename = null;
		model.gpxContent = null;
		model.gpxUploadDatum = null;

		context.setState({
			originalGpxContent: null,
			routeModel: null,
			mapBounds: [],
			model,
			gpxDropped: false,
			gpxDeleted: true,
			hasUnsavedChanges: true
		}, () => this.resetGpx());
	}

	downloadGPXBestand() {
		let context = this.context;
		let model = context.state.model;
		this.createAndServeFile(model.gpxFilename, model.gpxContent);
	}

	createAndServeFile(filename, filecontent) {
		if (window.navigator && window.navigator.msSaveBlob)                                                            //IE11 compatibility, using an ancient api
			window.navigator.msSaveBlob(new Blob([filecontent], { type: 'application/xml' }), filename);
		else {                                                                                                          //other browsers
			let a = window.document.createElement('a');
			a.href = window.URL.createObjectURL(new Blob([filecontent], { type: 'application/xml' }));
			a.download = filename;

			document.body.appendChild(a);
			a.click();
			document.body.removeChild(a);
		}
	}


	save(mapRef, routeFitted) {
		const ajaxActions = this.context.props.ajaxActions;

		let errors = null;
		let context = this.context;
		let model = context.state.model;

		context.filesHelper.commitSession();
		//todo rework documentsModel server side to avoid this
		let fileBaseUrl = this.context.filesHelper.getBaseFileLocation();
		let documentsForSave = formatFilesForSave(context.state.fileComponents, fileBaseUrl);

		if (context.state.gpxChanged) {
			context.setState({
				showGPXChangedPopup: true,
			});
		}

		ajaxActions.started();


		// Timeout to make sure map rendered before taking picture.
		routeFitted.then(() => setTimeout(() => {
			const mapContainer = mapRef && mapRef.current ? mapRef.current.getElementsByClassName("leaflet-container")[0] : undefined;
			domToImage.toPng(mapContainer, { imagePlaceholder: types.TRANSPARENT_PIXEL_PNG })
				.then(mapPhoto => {
					model.mapPhoto = mapPhoto.split(',')[1];
					lusApi.saveLus(model, documentsForSave)
						.then(response => {
							ajaxActions.ended();
							if (response.statusText === "OK" && !response.data.hasValidationErrors) {
								if (Object.keys(response.data.validationResults).length !== 0) {
									model = assign({}, response.data.item);
									errors = assign({}, response.data.validationResults);

									const errorsLength = Object.keys(errors).length;
									const gemeentenError = errors['gemeenten'];

									if (gemeentenError) {
										showToastrWarning(gemeentenError, true);
										if (errorsLength > 1) {
											showToastrWarning(messages.MESSAGE_VALIDATION_ERRORS_SAVED, true);
										}
									} else {
										showToastrWarning(messages.MESSAGE_VALIDATION_ERRORS_SAVED, true);
									}
								} else {
									model = assign({}, response.data.item, {});
									errors = {};
								}

								showToastrSuccess(messages.MESSAGE_SAVED, true);

								if (context.state.gpxDropped && !(model.straten && model.straten.length))
									showToastrInfo("De stratenlijst van je route wordt berekend.");

								this.loadRouteModel(model.gpxContent);

								context.setState({
									originalGpxContent: model.gpxContent,
									hasUnsavedChanges: false,
									scrollToTop: true,
									gpxDropped: false,
									routeEdited: false,
									gpxDeleted: false
								});
							} else {
								errors = assign({}, response.data.validationResults);
								model = assign({}, response.data.item, {});
								showToastrError(messages.MESSAGE_VALIDATION_ERRORS);
							}

							context.props.validatieStatussenLoaded(model.validatiestatusses);

							if (model.showANBWarning) {
								showToastrWarning("Dossiers die minder dan 35 dagen voor de tocht worden ingediend kunnen niet meer door ANB beoordeeld worden. De routes van deze tocht mogen niet door ANB gebied lopen. Gelieve je routes aan te passen.", true, true);
							}
							if (model.showAWVWarning) {
								showToastrWarning("Dossiers die minder dan 35 dagen voor de tocht worden ingediend kunnen niet meer door het Agentschap Wegen en Verkeer beoordeeld worden.	De routes van deze tocht mogen niet langs Gewestwegen/Autosnelwegen lopen of Gewestwegen kruisen. Gelieve je route aan te passen.", true, true);
							}

							context.setState({
								errors: errors,
								validationMessageType: response.data.hasValidationErrors ? ValidationMessageTypes.ERROR : ValidationMessageTypes.WARNING,
								model,
								showAnbPopup: model.showAnbPopup,
								shouldScrollToFirstError: true
							});

							if (errors && errors.gpxContent && errors.gpxContent.includes("Je GPX bestand bevat enkel punten maar geen route"))
								this.deleteGPXBestand();
						})
						.catch((ex) => {
							ajaxActions.failed();
							context.props.throwException(ex);
						});
				})
				.catch(error => {
					ajaxActions.failed();
					context.props.throwException(error);
					console.error('Error capturing map:', error);
				});

		}, 1000));

	}

	gemeenteGewijzigd(confirmed) {
		this.context.setState({
			gpxChanged: false,
			showGPXChangedPopup: false
		});
		if (confirmed) {
			const tochtId = this.context.props.match.params.modelId;
			this.redirector.goTo("/e-loket/veldtoertocht/" + tochtId + "#gemeenten");
		}

	}

	hideErrors(errorsToHide) {
		let clonedErrors = cloneDeep(this.context.state.errors);

		if (clonedErrors !== null && clonedErrors !== undefined) {
			for (let index = 0; index < errorsToHide.length; index++) {
				const element = errorsToHide[index];
				delete clonedErrors[element];
			}

			this.context.setState({
				errors: clonedErrors
			});
		}
	}

	showError(errorToShow, message) {
		let clonedErrors = cloneDeep(this.context.state.errors);
		if (clonedErrors === null || clonedErrors === undefined) clonedErrors = [];
		clonedErrors[errorToShow] = message;
		this.context.setState({
			errors: clonedErrors
		});
	}

	confirmAnbPopup() {
		this.context.setState({
			showAnbPopup: false
		});
	}

	getStratenlijstFilesProps() {
		const context = this.context;
		const params = context.props.match.params;
		let lusId = params.lusId;
		let files = [];

		const model = context.state.model;
		const fileName = `stratenlijst ${model.tocht.naam} ${model.naam}.csv`;

		files.push({
			display: fileName,
			urlParam: lusId
		});

		const stratenlijstFilesProps = getFilesComponentProps(
			"Stratenlijst",
			"stratenlijst",
			prependRoot("/lus/", getApiRoot()),
			{
				stratenlijst: files
			},
			true, null, null, null, true, null, null, null);

		return stratenlijstFilesProps;
	}
}
